import styled from "styled-components";

// 레이아웃용
const FlexWrap = styled.div`
  display: flex;
`;
export const FlexWrapC = styled(FlexWrap)<{ $gap?: string, $justifyContent?: string, $alignItems?: string}>`
  flex-direction: column;
  gap: ${(props) => props.$gap || '0.5rem'};
  justify-content: ${(props) => props.$justifyContent || 'normal'};
  align-items: ${(props) => props.$alignItems || 'normal'};
`;
export const FlexWrapR = styled(FlexWrap)<{ $gap?: string, $justifyContent?: string, $alignItems?: string}>`
  flex-direction: row;
  gap: ${(props) => props.$gap || '0.5rem'};
  justify-content: ${(props) => props.$justifyContent || 'normal'};
  align-items: ${(props) => props.$alignItems || 'normal'};
`;


//label-input wrap
const InputWrap = styled.div`
  width: 100%;
  display: flex;
  position: relative;

  .required_value::after {
    position: absolute;
    content: "*";
    color: ${({theme}) => theme.newTheme.default.error};
  }
`;
export const InputWrapC = styled(InputWrap)<{ $gap?: string, $justifyContent?: string, $alignItems?: string}>`
  flex-direction: column;
  gap: ${(props) => props.$gap || '0.5rem'};
  justify-content: ${(props) => props.$justifyContent || 'normal'};
  align-items: ${(props) => props.$alignItems || 'normal'};
`;
export const InputWrapR = styled(InputWrap)<{ $gap?: string, $justifyContent?: string, $alignItems?: string}>`
  flex-direction: row;
  gap: ${(props) => props.$gap || '0.5rem'};
  justify-content: ${(props) => props.$justifyContent || 'normal'};
  align-items: ${(props) => props.$alignItems || 'normal'};
`;